import { axios } from '@Root/API'

export const create = (contact_id, program_course_id, payload) => {
	return axios.post('fee-details', { ...payload, contact_id, program_course_id })
}
